import { Container, Row, Col } from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"
import Logo from "/public/site-assets/svg/logo-black.svg"
import ImpellamGroup from "/public/site-assets/svg/impellam-group.svg"
import { useRouter } from 'next/router';
import Sourceflow from '/public/sourceflow_logo.svg';
import SocialLinks from '/components/SocialLinks';
import NewNavigationUK from "../../.sourceflow/new_navigation_uk.json";
import NewNavigationUS from "../../.sourceflow/new_navigation_us.json";
import FooterCopyrightNavigations from '../../.sourceflow/footer_copyright_navigations.json';
import FooterDocumentsNavigations from '../../.sourceflow/footer_documents_navigations.json';

export default function MainFooter({
    customClass = "",
}) {
    const router = useRouter();

    // Select navigation based on locale
    let selectedNavigation;
    if (router.asPath.startsWith("/us")) {
        selectedNavigation = NewNavigationUS;
    } else {
        selectedNavigation = NewNavigationUK;
    }

    // Now filter based on selectedNavigation
    const ParentMainNavigation = selectedNavigation.category_values.filter(post => post.parent.identifier === null);
    const ChildrenMainNavigation = selectedNavigation.category_values.filter(post => post.parent.identifier !== null);

    return (
        <section className={`${styles.root} ${customClass} position-relative`}>
            <Container>
                <div className="pt-5">
                    <Link href="/">
                        <a aria-label="Logo" title="SRG">
                            <Logo />
                        </a>
                    </Link>
                    <Row className="justify-content-between my-5">
                        {ParentMainNavigation.map((post, index) => {
                            const childrenForParent = ChildrenMainNavigation.filter((childPost) => childPost.parent.id === post.id);
                            // Skip rendering if no children exist
                            if (childrenForParent.length === 0) {
                                return null; // Exit early
                            }
                            return (
                                <Col key={index} md={6} lg={2} className="mb-3 mb-md-0">
                                    <p className="fw-bold mb-1">
                                        <Link href={post.url.en}>
                                            <a className="text-decoration-none">
                                                {post.title.en}
                                            </a>
                                        </Link>
                                    </p>
                                    <ul className="list-unstyled navigations">
                                        {ChildrenMainNavigation.filter((childPost) => childPost.parent.id === post.id).map((childPost, childpostIndex) => {
                                            const childrenForSubChild = ChildrenMainNavigation.filter((sub_childPost) => sub_childPost.parent.id === childPost.id);
                                            return(
                                                <li key={childpostIndex}>
                                                    <div>
                                                        {childPost.new_tab?.en ?
                                                            <Link href={childPost.url.en}>
                                                                <a className="sub-item-parent post-title" target="_blank" rel="noopener noreferrer">
                                                                    {childPost.title.en}
                                                                </a>
                                                            </Link>
                                                        :
                                                        !childPost.url.en || childPost.url.en === "#" ?
                                                            <p className="sub-item-parent text-muted fw-bold m-0">{childPost.title.en}</p>
                                                        :
                                                            <a className="sub-item-parent post-title" href={childPost.url.en}>
                                                                {childPost.title.en}
                                                            </a>
                                                        }
                                                    </div>
                                                    {childrenForSubChild.length > 0 && (
                                                        <ul className="list-unstyled navigations mb-3">
                                                            {childrenForSubChild.map((sub_childPost, sub_childPostIndex) => (
                                                                <li key={sub_childPostIndex}>
                                                                    {sub_childPost.new_tab?.en ?
                                                                        <Link href={sub_childPost.url.en}>
                                                                            <a className="sub-item post-title" target="_blank" rel="noopener noreferrer">
                                                                                {sub_childPost.title.en}
                                                                            </a>
                                                                        </Link>
                                                                    :
                                                                        <Link href={sub_childPost.url.en}>
                                                                            <a className="sub-item post-title">
                                                                                {sub_childPost.title.en}
                                                                            </a>
                                                                        </Link>
                                                                    }
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </Col>
                            )
                        })}
                        <Col md={6} lg={2}>
                            <p className="fw-bold mb-1">Documents</p>
                            <ul className="list-unstyled navigations">
                                {FooterDocumentsNavigations.category_values.map((post, index) => (
                                    <li key={index}>
                                        {post?.new_tab ?
                                            <Link href={`${post.link.en}`}>
                                                <a className="text-decoration-none" target="_blank" rel="noopener noreferrer">
                                                    {post.title.en}
                                                </a>
                                            </Link> :
                                            <Link href={`${router.pathname.startsWith("/us") ? "/us" : ""}${post.link.en}`}>
                                                <a className="text-decoration-none">
                                                    {post.title.en}
                                                </a>
                                            </Link>
                                        }
                                    </li>
                                ))}
                            </ul>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="navigations">
                            <p className="fw-bold mb-1">Get in Touch</p>
                            {router.pathname.startsWith("/us") ?
                                <p className="m-0">
                                    <Link href="mailto:connect@srgtalent.com">
                                        <a>
                                            {router.pathname.startsWith("/us") ? "connect@srgtalent.com" : ""}
                                        </a>
                                    </Link>
                                </p>
                            :
                                <p className="m-0">
                                    <Link href="mailto:info@srgtalent.com">
                                        <a>
                                            {router.pathname.startsWith("/") ? "info@srgtalent.com" : ""}
                                        </a>
                                    </Link>
                                </p>
                            }
                        </div>
                        <SocialLinks customClass="social-links d-flex align-items-end" />
                    </div>
                </div>
                <div className="d-flex flex-wrap flex-md-nowrap justify-content-between align-items-start mt-4">
                    <span className="impellem-group d-flex align-items-end me-4">
                        <small>Part Of</small>
                        <Link href="https://www.impellam.com/">
                            <a target="_blank" rel="noopener noreferrer" title="ImpellAm Group" className="ms-1">
                                <ImpellamGroup />
                            </a>
                        </Link>
                    </span>
                    {router.pathname.startsWith("/us") ? 
                    <div className="my-4 my-md-0">
                        <small>© SRG 43 High Street, Suite 120, N. Andover, MA 01845</small>
                    </div> : 
                    <div className="my-4 my-md-0">
                    <small>© SRG First Floor, Mulberry House, Parkland Square, 750 Capability Green, Luton, LU1 3LU</small>
                    </div>}
                    <div className="text-nowrap d-flex align-items-end">
                        <p className="mb-0 me-3"><small>© {new Date().getFullYear()} SRG.</small></p>
                        <p className="mb-0 me-1"><small>Site by</small></p>
                        <Link href="https://www.sourceflow.co.uk/">
                            <a className="sourceflow" rel="noopener noreferrer" target="_blank" title="SourceFlow">
                                <Sourceflow />
                            </a>
                        </Link>
                    </div>
                </div>
                <ul className="d-flex flex-wrap justify-content-md-center list-unstyled footer-navigations-2 mx-auto my-4 pt-3" style={{ maxWidth: '800px', borderTop: '1px solid #dfdfdf' }}>
                    {FooterCopyrightNavigations.category_values.map((post, index) => (
                        <li className="me-md-3 mb-1 pe-2 pe-md-0" key={index}>
                            {post.new_tab ?
                                <Link href={`${post.link.en}`}>
                                    <a className="text-decoration-none" target="_blank" rel="noopener noreferrer">
                                        <small>{post.title.en}</small>
                                    </a>
                                </Link> :
                                <Link href={`${router.pathname.startsWith("/us") ? "/us" : ""}${post.link.en}`}>
                                    <a className="text-decoration-none">
                                        <small>{post.title.en}</small>
                                    </a>
                                </Link>
                            }
                        </li>
                    ))}
                </ul>
            </Container>
        </section>
    )
}
